module.exports = __webpack_public_path__ + "fonts/bedtime stories.a63747f8.ttf";